/**
 * 新预览方法
 * qiuwenran 2022.09.05
 * !! 已经格式化处理过，禁止再格式化
 */
import { getToken, getContextPath, uniqueSortedArray } from "@/CommonDP/mongeView/utils";
import { mongeApp, mongeMutations } from "./store/mongeStore";
import enginerelease from "./enginerelease.js";
import * as uni from "./appView/component/uni.webview.1.5.2";
import Vue from "vue";
document.addEventListener("UniAppJSBridgeReady", function() {
  Vue.prototype.myUni = uni;
});
// 组件应用类
export class AppLication {
  expanded = false; // 是否展开
  hoverActive = false; // 鼠标是否悬浮
  actived = false; // 选中
  isMini = false; // 组件最小化
  heightLight = false; // 工具区展示，全应用唯一
  vm = undefined; // 挂载的Vue实例
  questionId = "";
  addType=false;//- addType项目用，同步误删，否则得改功能
  isNolightweight=false; // 是否需要轻量化
  constructor(option) {
    this.payload = option.payload || ""; // 负载数据
    this.id = option.id;
    this.isTools = option.isTools || false; // 不可动
    this.cnName = option.cnName;
    this.component = option.component;
    this.hasMark = option.hasMark;
    this.icon1 = option.icon1;
    this.icon0 = option.icon0;
    this.button = option.button;
    this.type = option.type;
    this.isNolightweight = option.isNolightweight || false;
  }

  // 组件最小化
  mini() {
    this.heightLight = false;
    if (this.component) this.isMini = true;
    if (this.id === "list") mongeMutations.setHasList(false);
  }
  openTools() {
    this.heightLight = true;
    this.isMini = false;
    if (this.id === "list") mongeMutations.setHasList(true);
  }
  closeTools() {
    this.heightLight = false;
    if (this.id === "list") mongeMutations.setHasList(false);
  }
  // 打开组件
  open(questionId, fileType,addType) {
    this.actived = true;
    this.questionId = questionId || "";
    this.heightLight = true;
    this.isMini = false;
    if (this.hasMark === "down") this.hasMark = "up";
    if (this.id === "list") {
      mongeMutations.setHasList(true);
      this.addType=addType//- addType项目用，同步误删，否则得改功能
    }
    // 没有页面的需要的功能
    if (!this.component) {
      openMongeApi(this.id, this.type, fileType, {
        callback: () => {
          this.actived = false;
        }
      });
    }
  }
  close() {
    this.actived = false;
    this.isMini = false;
    this.heightLight = false;
    if (this.hasMark === "up") this.hasMark = "down";
    closeMongeApi(this.id);
  }
}
async function openMongeApi(id, type, fileType, call) {
  const openDescribe = {
    "amplifications": async() => { // 框选放大
      call.callback(type === "model" ? await mongeApiMlib.zoom3D(true) : await mongeApiMlib.zoom2D(true));
    },
    "globe": async() => { // 地图
      mongeApiMlib.globeLocation();
    },
    "reset": () => { // H5图纸复位
      call.callback(type === "model" ? mongeApiMlib.modelFitToAll() : mongeApiMlib.mapFitToAll());
    },
    "list": () => { // H5 批注列表
      if (type === "other") call.callback(mongeApiMlib.openH5Otherlist(fileType));
    }
  };
  openDescribe[id] ? openDescribe[id]() : console.log("暂不处理");
}
function closeMongeApi(id) {
  const closeDescribe = {
    "amplifications": () => enginerelease.closeAmplifications(),
    "measure": () => enginerelease.closeMeasure(), // 图纸测量
    "pencil": () => enginerelease.closePencil(), // 画笔
    "overlay": () => enginerelease.closeOverlay(), // 叠图
    "issue": () => enginerelease.closeIssue(), // 批注
    "list": () => enginerelease.closeList(), // 批注列表
    "notation": () => enginerelease.closeIssue(), // 批注H5
    "detail": () => enginerelease.closeDetail(), // 关闭批注详情
    "modelMini": () => enginerelease.closeModelMini(), // 小地图
    "modelMeaure": () => enginerelease.closeModelMeaure(), // 模型测量
    "section": () => enginerelease.closeSection(), // 模型剖切
    "globe": () => enginerelease.closeGlobe(),
    "comparison": () => enginerelease.closeComparison(), // 版本比对
    "modelOverlay": () => enginerelease.closeModelOverlay(), // 二三维叠图
    "modelOverlayTool": () => enginerelease.closeModelOverlayTool(),
    "areaPlane": () => enginerelease.closeAreaPlane(), // 模型空间
    "modelSectionH5": () => enginerelease.closeModelSectionH5(), // 模型剖切H5
    "modelTree": () => enginerelease.closeModelTree(), // 模型树(H5使用)
    "modelAttr": () => enginerelease.closeModelAttr()// 模型属性(H5使用)
  };
  closeDescribe[id] ? closeDescribe[id]() : "";
}
let dwgDataList;
const mongeApiMlib = {
  getContextLocation() {
    return location.origin + getContextPath();
  },
  // 启动新的模式， true 为启用
  isOssFile() {
    return mongeApp.mlibEnabled || false;
  },
  // 拼装图纸url，同时获取该图纸空间
  assembleUrl(data) {
    if (data.length > 0) {
      dwgDataList = [];
      for (const iterator of data) {
        if (iterator.fileStatus === 2) {
          const picsurl = getToken()
            ? this.getContextLocation() + `/doc/unzip-file/preview/${iterator.convertFilePathId}?token=${getToken()}&fileName=/`
            : this.getContextLocation() + `/doc/share/unzip-file/preview/${iterator.convertFilePathId}?fileName=/`;
          const picName = iterator.fileName;
          const id = iterator.convertFilePathId;
          dwgDataList.push({ id, picName, picsurl });
        }
      }
      return dwgDataList;
    } else {
      Promise.reject("图纸异常，无图纸空间");
    }
  },
  // 新模式加载图纸
  dealMongeFiles(data = {}) {
    dwgDataList = [];
    const lightFileList = data.lightFileList || [];
    if (lightFileList.length === 0) {
      return false;
    }
    const spaceNamesRaw = lightFileList.sort((a, b) => a.dwgIndex - b.dwgIndex).map((item) => item.drawName);
    const spaceNames = uniqueSortedArray(spaceNamesRaw);
    const spaces = spaceNames.map((spaceName) => {
      return {
        // 下面2行为兼容而设置的属性
        fileName: spaceName,
        convertFilePathId: spaceName,
        fileId: data.fileId || "",
        // 下面的属性与引擎已约定好的
        bimexName: spaceName,
        bimexId: spaceName,
        bimexDetailList: []
      };
    });
    lightFileList.forEach((e) => {
      if (!e.drawName) {
        return;
      }
      const index = spaceNames.indexOf(e.drawName);
      if (index < 0) {
        return;
      }
      const bimexItemFile = {
        originFileName: e.lightFileName,
        url: e.downloadUrl,
        fileId: e.fileId
      };
      spaces[index].bimexDetailList.push(bimexItemFile);
      spaces[index].index = e.dwgIndex;
    });
    dwgDataList = spaces;
    return dwgDataList;
  },
  getDwgSpaceList() {
    return dwgDataList;
  },
  // 拼装模型url，
  assembleModelUrl(data) {
    if (data.length > 0) {
      const modelDataList = [];
      data.forEach((element) => {
        if (element.fileType === 3) {
          const picsurl = getToken()
            ? this.getContextLocation() + `/doc/unzip-file/preview/${element.id}?token=${getToken()}&fileName=/`
            : this.getContextLocation() + `/doc/share/unzip-file/preview/${element.id}?fileName=/`;
          modelDataList.push(picsurl);
        }
      });
      return modelDataList;
    } else {
      Promise.reject("模型异常，没有获取到模型数据");
    }
  },
  // 拼装模型图纸url
  assembleMapUrl(data, modelFileId, rvtVersion) {
    if (data.length === 0) return [];
    const dwgDataList = [];
    for (const iterator of data) {
      if (iterator.fileType === 2 && iterator.parentId === "SheetViews") {
        const picsurl = getToken()
          ? this.getContextLocation() + `/doc/unzip-file/preview/${iterator.id}?token=${getToken()}&fileName=/`
          : this.getContextLocation() + `/doc/share/unzip-file/preview/${iterator.id}?fileName=/`;
        const imgurl = getToken()
          ? this.getContextLocation() + `/doc/unzip-file/preview/image/${iterator.id}?token=${getToken()}&fileName=/`
          : this.getContextLocation() + `/doc/share/unzip-file/preview/image/${iterator.id}?fileName=/`;
        const picName = encodeURIComponent(iterator.fileName);
        const imgId = iterator.id;
        const paperId = iterator.paperId;
        dwgDataList.push({ picName, picsurl, imgurl, imgId, paperId, modelFileId, rvtVersion });
      }
    }
    return dwgDataList;
  },
  dealMongeModelFiles(data) {
    let lightFileList = data.lightFileList || [];
    lightFileList = lightFileList.filter(item => item.label !== "2D");
    if (lightFileList.length === 0) {
      return false;
    }
    const bimexDetailFiles = lightFileList.map((item) => {
      return {
        originFileName: item.lightFileName,
        url: item.downloadUrl,
        fileId: item.fileId,
        ...item
      };
    });
    const models = [];
    models.push({
      bimexName: data.fileName,
      bimexId: data.fileId,
      bimexDetailList: bimexDetailFiles
    });
    return models;
  },
  // 加载图纸引擎
  async loadDwg(url, dom, boolean) {
    await enginerelease.EngineResources();
    await this.loadMap(url, dom, boolean);
  },
  /**
   * 图纸加载
   * @param {string} url
   * @param {string} dom
   * @param {string} longforLoading //过度动画是否水平垂直居中
   */
  async loadMap(url, dom, longforLoading) {
    await enginerelease.loadMap(url, dom, longforLoading);
  },
  // 图纸复位
  mapFitToAll() {
    enginerelease.mapFitToAll();
  },
  // 加载模型引擎
  async loadModel(url, dom, boolean) {
    await enginerelease.EngineResources();
    this.load3D(url, dom, boolean);
  },
  /**
   * 加载模型
   */
  async load3D(url, dom, boolean) {
    await enginerelease.loadModel(url, dom, boolean);
  },
  // 加载不需要轻量化模型引擎
  async loadNoLightweightModel(url, dom, fileType, boolean) {
    await enginerelease.EngineResources();
    this.loadNoLightweight3D(url, dom, fileType, boolean);
  },
  async loadNoLightweight3D(url, dom, fileType, boolean) {
    await enginerelease.loadNoLightweight3D(url, dom, fileType, boolean);
  },
  // 鼠标右键属性
  onContextmenu(data) {
    enginerelease.onContextmenu(data);
  },
  /**
   * @description: 模型图纸，做联动
   * @param {url} 图纸url
   * @param {id}  图纸dom元素
   * @param {longforLoading} 加载图位置是否水平垂直
   * @param {modelFileId} 模型id
   */
  async load2D(params) {
    await enginerelease.loadModelMap(params);
  },
  // 模型复位
  modelFitToAll() {
    enginerelease.modelFitToAll();
  },
  getModels() {
    return enginerelease.getModels();
  },
  // 开启虚拟摇杆
  JoyStickerActive() {
    enginerelease.JoyStickerActive();
  },
  // 开始行走
  JoyStickerStart() {
    enginerelease.JoyStickerStart();
  },
  // 行走
  JoyStickerWalk(force, angle) {
    enginerelease.JoyStickerWalk(force, angle);
  },
  // 停止行走
  JoyStickerEndWalk() {
    enginerelease.JoyStickerEndWalk();
  },
  joyStickmoveUp(boolean) {
    enginerelease.joyStickmoveUp(boolean);
  },
  joyStickmoveDown(boolean) {
    enginerelease.joyStickmoveDown(boolean);
  },
  getAttrTree() {
    return enginerelease.getAttrTree();
  },
  closeMap() {
    enginerelease.closeMap();
  },
  resize() {
    enginerelease.resize();
  },
  // 图纸选框放大
  async zoom2D(switchBoolean) {
    switchBoolean = await enginerelease.zoom2D(switchBoolean);
  },
  // 清除图纸测量
  clearMapMeasure() {
    enginerelease.clearMapMeasure();
  },
  // 关闭图纸测量
  deactiveMapMeasure() {
    enginerelease.deactiveMapMeasure();
  },
  /**
   * @description: 图纸测量
   * @param {ToolBase} 测量类型
   * @param {unit} 测量单位
   * @param {continuous} 是否连续测量
   * @param {switchBoolean} 回调
   * @return 没有返回信息写 void / 有返回信息 {返回类型} 描述信息
   */
  measure2D(ToolBase, unit, continuous, switchBoolean) {
    return enginerelease.measure2D(ToolBase, unit, continuous, switchBoolean);
  },
  /**
   * @description: 图纸测量H5
   * @param {ToolBase} 测量类型
   * @param {call} 回调
   */
  async measureH52D(ToolBase, call) {
    enginerelease.measureH52D(ToolBase, {
      callback: (type, data) => {
        call.callback(type, data);
      }
    });
  },
  // 结束当前面积测量
  measureH5closeArea() {
    enginerelease.measureH5closeArea();
  },
  // 清除画笔
  clearPencil() {
    enginerelease.clearPencil();
  },
  // 关闭画笔
  endPencil() {
    enginerelease.pencilDeactive();
  },
  // 显示所有绘制内容
  showPencilAll() {
    enginerelease.showPencilAll();
  },
  // 隐藏所有绘制内容
  hiddenPencilAll() {
    enginerelease.hiddenPencilAll();
  },
  // 删除选中的画笔
  pencilRemoveById(id) {
    enginerelease.pencilRemoveById(id);
  },
  // 关闭画笔工具
  pencilDeactive() {
    enginerelease.pencilDeactive();
  },
  /**
   * @description: 画笔
   * @param {pencilType} 画笔类型
   * @param {color} 画笔颜色
   * @param {size} 画笔尺寸
   * @param {isContinue} 连续
   * @return 没有返回信息写 void / 有返回信息 {返回类型} 描述信息
   */
  async pencil2D(pencilType, color, lineWidth, fontSize, isContinue) {
    return await enginerelease.pencil2D(pencilType, color, lineWidth, fontSize, isContinue);
  },
  /**
   * @description: 画笔H5
   * @param {pencilType} 画笔类型
   * @param {color} 画笔颜色
   * @param {size} 画笔尺寸
   * @return 没有返回信息写 void / 有返回信息 {返回类型} 描述信息
   */
  pencilH52D(pencilType, color, lineWidth, fontSize, call) {
    enginerelease.pencilH52D(pencilType, color, lineWidth, fontSize, {
      callback: (type, data) => {
        call.callback(type, data);
      }
    });
  },
  // 画笔设置字体内容
  pencilSetText(text) {
    enginerelease.pencilSetText(text);
  },
  // 画笔设置字体大小
  pencilSetFontSize(id, value) {
    enginerelease.pencilSetFontSize(id, value);
  },
  // 画笔设置线宽
  pencilSetLineWidth(id, value) {
    enginerelease.pencilSetLineWidth(id, value);
  },
  // 画笔设置颜色
  pencilSetColor(id, value) {
    enginerelease.pencilSetColor(id, value);
  },
  // 关闭当前图层
  mapAddSelectionEvent() {
    enginerelease.mapMapToolAddSelectionEvent(1);
  },
  // 移除关闭当前图层事件
  removeAddSelectionEvent() {
    enginerelease.removeAddSelectionEvent();
  },
  // 关闭其他图层
  async mapOtherSelectionEvent() {
    enginerelease.mapMapToolAddSelectionEvent(2);
  },
  // 移除关闭其他图层事件
  removeMapOtherSelectionEvent() {
    enginerelease.removeMapOtherSelectionEvent();
  },
  // 图层
  async mapLayers() {
    return await enginerelease.mapLayers();
  },
  // 控制图层显隐
  setVisibleById(id, isVisible) {
    enginerelease.setVisibleById(id, isVisible);
  },
  // 图层全选或反选
  setAllVisible(boolean) {
    enginerelease.setAllVisible(boolean);
  },
  // 图纸版本对比
  async mapCompare(url) {
    return await enginerelease.mapCompare(url);
  },
  // 取消图纸版本对比
  cancelMapCompare() {
    enginerelease.cancelMapCompare();
  },
  // 开始叠图
  async loadDrawing(url, color) {
    return await enginerelease.loadDrawing(url, color);
  },
  // 卸载叠图
  unloadDrawing(url) {
    enginerelease.unloadDrawing(url);
  },
  // 获取叠图的id
  async getMapId(url) {
    return await enginerelease.getMapId(url);
  },
  // 加载叠图后-平移
  mapMove(url) {
    enginerelease.mapMove(url);
  },
  // 加载叠图后-缩放
  mapScale(url) {
    enginerelease.mapScale(url);
  },
  // 加载叠图后-重置
  mapReset(url) {
    enginerelease.mapReset(url);
  },
  // 图纸添加云线
  async addAnnotation(color, call) {
    enginerelease.addAnnotation(color, {
      callback: (type, data) => {
        call.callback(type, data);
      }
    });
  },
  // 停止矩形批注
  annotationEnd() {
    enginerelease.annotationEnd();
  },
  setMapText(val) {
    enginerelease.setMapText(val);
  },
  // 截屏 设置为true时返回canvas，设置为false时返回dataUrl
  async mongeScreenCapture(boolean, type) {
    if (type === "dwg") {
      return await enginerelease.screenCaptureMap(boolean);
    } else if (type === "model") {
      return await enginerelease.screenCaptureModel(boolean);
    } else if (type === "modelDwg") {
      return await enginerelease.screenCaptureModelMap(boolean);
    }
  },
  // 关闭批注
  annotationDeactive() {
    enginerelease.annotationDeactive();
  },
  // 展示云线
  annoShow(id, data, color) {
    enginerelease.annoShow(id, data, color);
  },
  // 展示锚点
  showMark(id, data) {
    enginerelease.showMark(id, data);
  },
  // 创建模型锚点
  addMark3D(color, call) {
    enginerelease.addMark3D(color, {
      callback: (data) => {
        call.callback(data);
      }
    });
  },
  // 获取模型相机位置
  async getViewport() {
    return await enginerelease.getViewport();
  },
  // 定位单个云线
  mapAim(id, item, color) {
    enginerelease.mapAim(id, item, color);
  },
  // 定位模型
  modelAim(id, data, viewportData, fileName, callback) {
    enginerelease.modelAim(id, data, viewportData, fileName, callback);
  },
  // 清空云线锚点数据
  clearAnnotation() {
    enginerelease.clearAnnotation();
  },
  // 碰撞
  startCalculate(collisionType, softDis, data, call) {
    enginerelease.startCalculate(collisionType, softDis, data, {
      callback: (data) => {
        call.callback(data);
      }
    });
  },
  // 碰撞数据
  getCollisionData(start, count) {
    return enginerelease.getCollisionData(start, count);
  },
  // 定位到构件
  fitToInsert(id) {
    enginerelease.fitToInsert(id);
  },
  // 导出
  exportExcel() {
    enginerelease.exportExcel();
  },
  // 模型碰撞时用到(一个模型的数据树)
  loadOneModelData(node, modelId) {
    return enginerelease.loadOneModelData(node, modelId);
  },
  // 同步模型树
  async getTreeData() {
    return await enginerelease.getTreeData();
  },
  // 构件隐藏
  elementIdHide(modelId, elementId) {
    enginerelease.elementIdHide(modelId, elementId);
  },
  // 构件显示
  elementIdShow(modelId, elementId) {
    enginerelease.elementIdShow(modelId, elementId);
  },
  elementShowAll() {
    enginerelease.elementShowAll();
  },
  elementIsHide(modelId, elementId) {
    return enginerelease.elementIsHide(modelId, elementId);
  },
  // 模型树-异步
  loadTreeData(node) {
    return enginerelease.loadTreeData(node);
  },
  async loadNextData(node) {
    return enginerelease.loadNextData(node);
  },
  getTreeNodeId(modelId, elementId) {
    return `${modelId}_${elementId}`;
  },
  // 模型系统
  async loadSysData() {
    return enginerelease.loadSysData();
  },
  // 高亮定位
  selectPick(data) {
    enginerelease.selectPick(data);
  },
  // 取消之前选择
  cancelSelectPick() {
    enginerelease.cancelSelectPick();
  },
  // 框选放大
  async zoom3D(switchBoolean) {
    switchBoolean = await enginerelease.zoom3D(switchBoolean);
  },
  // 三维地球
  globeLocation() {
    enginerelease.globeLocation();
  },
  // 模型清除测量
  clearMeasure() {
    enginerelease.clearMeasure();
  },
  /**
   * @description: 模型测量
   * @param {ToolBase} 测量类型
   * @param {unit} 测量单位
   * @param {continuous} 是否连续测量
   * @param {enableSnapper} 设置捕捉功能开启和关闭
   * @param {switchBoolean} 回调
   * @return 没有返回信息写 void / 有返回信息 {返回类型} 描述信息
   */
  async measure3D(ToolBase, unit, continuous, enableSnapper, switchBoolean) {
    return await enginerelease.measure3D(ToolBase, unit, continuous, enableSnapper, switchBoolean);
  },
  /**
   * @description: 模型测量H5
   * @param {ToolBase} 测量类型
   * @param {unit} 测量单位
   * @param {continuous} 是否连续测量
   * @param {enableSnapper} 设置捕捉功能开启和关闭
   * @param {call} 回调
   * @return 没有返回信息写 void / 有返回信息 {返回类型} 描述信息
   */
  measureH53D(ToolBase, call) {
    enginerelease.measureH53D(ToolBase, {
      callback: (type) => {
        call.callback(type);
      }
    });
  },
  // 关闭测量
  deactiveMeasure() {
    enginerelease.deactiveMeasure();
  },
  // 取消剖切
  deactiveSection() {
    enginerelease.deactiveSection();
  },
  /**
   * @description: 模型剖切
   * @param {ToolBase} 剖切类型
   * @param {showSectionPlane} 是否显示剖切平面
   * @param {showSectionHandle} 是否显示剖切把手
   * @param {showSectionFill} 是否显示填充面
   */
  section3D(ToolBase, showSectionPlane, showSectionHandle, showSectionFill) {
    enginerelease.section3D(ToolBase, showSectionPlane, showSectionHandle, showSectionFill);
  },
  // 获得剖切模式
  getSectionMode() {
    return enginerelease.getSectionMode();
  },
  // 获得剖切位置(x,y,z,box)
  getSectionPos(type) {
    return enginerelease.getSectionPos(type);
  },
  // 设置剖切位置(x,y,z,box)
  setSectionPos(mode, position) {
    enginerelease.setSectionPos(mode, position);
  },
  /**
   * @description: 二三维叠图使用
   * @param {val} 剖切位置
   */
  setSection(val) {
    enginerelease.setSection(val);
  },
  // 模型上叠加图纸
  async startModelOverlay(url) {
    return await enginerelease.startModelOverlay(url);
  },
  startDrawing(drawing) {
    enginerelease.startDrawing(drawing);
  },
  // 模型上卸载图纸
  unloadModelDrawing(drawing) {
    enginerelease.unloadModelDrawing(drawing);
  },
  closeModelOverlay() {
    enginerelease.closeModelOverlay();
  },
  // 图纸对齐工具
  transformMap(drawing) {
    enginerelease.transformMap(drawing);
  },
  getbboxmax() {
    return enginerelease.getbboxmax();
  },
  getbboxmin() {
    return enginerelease.getbboxmin();
  },
  addFrame(call) {
    enginerelease.addFrame({
      callback: (obj) => {
        call.callback(obj);
      }
    });
  },
  startRoaming(path, call) {
    enginerelease.startRoaming(path, {
      callback: (val) => {
        call.callback(val);
      }
    });
  },
  // 关闭漫游
  stopRoaming() {
    enginerelease.stopRoaming();
  },
  // 关闭图纸对齐工具
  stopTransformMap() {
    enginerelease.stopTransformMap();
  },
  setViewport(viewport) {
    enginerelease.setViewport(viewport);
  },
  // 构件剖切
  sectionArt3D() {
    enginerelease.sectionArt3D();
  },
  // 模型版本比对
  async modelCompare(url) {
    return await enginerelease.modelCompare(url);
  },
  needUpdate() {
    enginerelease.needUpdate();
  },
  // 取消模型版本对比
  cancelModelCompare() {
    enginerelease.cancelModelCompare();
  },

  // 是否选中构件
  selectCheck() {
    return enginerelease.selectCheck();
  },
  // 设置构件颜色
  setElementColor(color) {
    enginerelease.setElementColor(color);
  },
  // 重置构件所有颜色
  resetElementColor() {
    enginerelease.resetElementColor();
  },
  // 获取模型所有标高
  getLevels() {
    return enginerelease.getLevels();
  },
  // 小地图
  changeMini(val, showName, call) {
    enginerelease.changeMini(val, showName, {
      callback: (num) => {
        call.callback(num);
      }
    });
  },
  // 小地图H5
  changeMiniH5(val, showName, call) {
    enginerelease.changeMiniH5(val, showName, {
      callback: (num) => {
        call.callback(num);
      }
    });
  },
  miniDective() {
    enginerelease.miniDective();
  },
  setMiniHeight(val) {
    enginerelease.setMiniHeight(val);
  },
  setNameShow(flag) {
    enginerelease.setNameShow(flag);
  },
  showSpaceName(params) {
    enginerelease.showSpaceName(params);
  },
  // 房间列表
  spaceView(levelId) {
    return enginerelease.spaceView(levelId);
  },
  // 点击房间名称
  selectOnlyOneById(revitId) {
    enginerelease.selectOnlyOneById(revitId);
  },
  // 框选房间
  selectByRect() {
    enginerelease.selectByRect();
  },
  // 图纸背景色 0xff0000或者"#ff0000"
  set2DBgc(val) {
    enginerelease.set2DBgc(val);
  },
  // 设置模型背景色 颜色为 RGB的数组
  set3DBgc(value) {
    enginerelease.set3DBgc(value);
  },
  get3DBgc() {
    return enginerelease.get3DBgc();
  },
  // 天空盒
  setSkyBox() {
    enginerelease.setSkyBox();
  },
  // 交互配置项
  walkOption3D() {
    return enginerelease.walkOption3D();
  },
  // 效果配置项
  contour() {
    return enginerelease.contour();
  },
  environment() {
    return enginerelease.environment();
  },
  changeBgc(val) {
    enginerelease.changeBgc(val);
  },
  changeWeather(val) {
    enginerelease.changeWeather(val);
  },
  weatherType() {
    return enginerelease.weatherType();
  },
  weatherIntensityList() {
    return enginerelease.weatherIntensityList();
  },
  getweatherIntensity() {
    return enginerelease.getweatherIntensity();
  },
  changeWeatherIntensity(val) {
    enginerelease.changeWeatherIntensity(val);
  },
  // 选择配置项
  selector() {
    return enginerelease.selector();
  },
  // 漫游速度
  changeSpeed(value) {
    enginerelease.changeSpeed(value);
  },
  // 旋转速度
  changeRotateSpeed(value) {
    enginerelease.changeRotateSpeed(value);
  },
  // 固定Z轴
  changefixedZAxis(value) {
    enginerelease.changefixedZAxis(value);
  },
  // 绕模型旋转速度
  changeFocusModelRotateSpeed(val) {
    enginerelease.changeFocusModelRotateSpeed(val);
  },
  changeZoomSpeed(val) {
    enginerelease.changeZoomSpeed(val);
  },
  // //绕模型旋转
  changeFocusModel(val) {
    enginerelease.changeFocusModel(val);
  },
  // 鼠标悬停效果
  changeHoverEnable(val) {
    enginerelease.changeHoverEnable(val);
  },
  // 选择呼吸效果
  changeSelectionFlash(val) {
    enginerelease.changeSelectionFlash(val);
  },

  // 碰撞检测
  changeCollide(value) {
    enginerelease.changeCollide(value);
  },
  // 重力
  changeGravity(value) {
    enginerelease.changeGravity(value);
  },
  // 渲染效果配置项
  effectOption3D() {
    return enginerelease.effectOption3D();
  },
  // 模型边线
  changeFouLine(value) {
    enginerelease.changeFouLine(value);
  },
  // 抗锯齿FXAA
  changeFxaa(value) {
    enginerelease.changeFxaa(value);
  },
  // 环境光遮蔽
  changeSsao(value) {
    enginerelease.changeSsao(value);
  },
  // 阴影
  changeShadow(value) {
    enginerelease.changeShadow(value);
  },
  // 曝光自适应
  changeAutomaticExposure(value) {
    enginerelease.changeAutomaticExposure(value);
  },
  // 亮度
  changeIntensity(value) {
    enginerelease.changeIntensity(value);
  },
  // 饱和度
  changeSaturation(value) {
    enginerelease.changeSaturation(value);
  },
  // 色温列表
  curTemperatureList() {
    return enginerelease.curTemperatureList();
  },
  // 背景列表
  getBgcList() {
    return enginerelease.getBgcList();
  },
  // 色温
  changeTemperature(value) {
    enginerelease.changeTemperature(value);
  },
  // 天空盒时间
  changeTime(val) {
    enginerelease.changeTime(val);
  },
  /**
   * @description: 以下方法为H5和uniapp直接的交互应用
   */
  // 初始化监听事件
  initEvent() {
    document.addEventListener("touchstart", this.touch2mouse, true);
    document.addEventListener("touchmove", this.touch2mouse, true);
    document.addEventListener("touchend", this.touch2mouse, true);
    document.addEventListener("touchcancel", this.switch2touch, true);
  },
  // dwg页面转换手机端处理触屏事件
  touch2mouse(event) {
    var touches = event.changedTouches;
    var first = touches[0];
    var type = "";
    switch (event.type) {
      case "touchstart":
        type = "mousedown";
        break;
      case "touchmove":
        type = "mousemove";
        break;
      case "touchend":
        type = "mouseup";
        break;
      default:
        return;
    }
    var simulatedEvent = document.createEvent("MouseEvent");
    simulatedEvent.initMouseEvent(type, true, true, window, 1, first.screenX, first.screenY, first.clientX, first.clientY,
      false, false, false, false, 0 /* left*/, null);
    first.target.dispatchEvent(simulatedEvent);
  },
  openH5Otherlist(fileType) {
    const filData = JSON.parse(mongeApp.other.fileInfo);
    const { fileId, fileName, fileVersion, prjId } = filData;
    const data = {
      fileId,
      fileName,
      fileType,
      versionIds: fileVersion,
      prjId,
      source: "list"
    };
    this.uniPostMessage(data);
  },
  // 返回上一页
  rebackLastPage(isH5, data) {
    if (isH5) {
      window.history.go(-1);
    } else {
      // #ifdef APP-PLUS
      uni.postMessage({ data });
      // #endif
      // #ifdef H5
      if (window.opener) {
        window?.opener?.postMessage({ data });
      }
      // #endif
    }
    if (window.WeixinJSBridge) {
      // 在微信中
      // 这个可以关闭安卓系统的手机
      document.addEventListener(
        'WeixinJSBridgeReady',
        function () {
          window.WeixinJSBridge.call('closeWindow');
        },
        false
      );
      // 这个可以关闭ios系统的手机
      window.WeixinJSBridge.call('closeWindow');
    } else {
      // 在其他浏览器中
      window.close();
    }
  },
  uniPostMessage(data) {
    // #ifdef APP-PLUS
    uni.postMessage({ data });
    // #endif
    // #ifdef H5
    if (window.opener) {
      window?.opener?.postMessage({ data });
    }
    // #endif
  }
};
export default mongeApiMlib;
